// Forever Forward — shop
// Sidebar collection selector that swaps the active product grid entirely
// client-side. Each collection's products are pre-rendered into the page
// and toggled by [hidden]; switching fades the grid out, swaps, fades in,
// and re-triggers the reveal animation on the incoming cards.

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initShop(root) {
    if (!root || root.dataset.ffShopReady === 'true') return;
    root.dataset.ffShopReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ff-shop-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ff-shop-panel]'));
    if (!tabs.length || !panels.length) return;

    function panelFor(id) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-ff-shop-panel') === id) return panels[i];
      }
      return null;
    }

    function revealCards(panel) {
      var cards = panel.querySelectorAll('.ff-shop-card');
      for (var i = 0; i < cards.length; i++) {
        (function (card, idx) {
          card.classList.remove('is-in');
          window.setTimeout(function () {
            card.classList.add('is-in');
          }, reduced ? 0 : Math.min(idx * 45, 400));
        })(cards[i], i);
      }
    }

    function activate(id, focusTab) {
      var nextPanel = panelFor(id);
      if (!nextPanel) return;

      tabs.forEach(function (t) {
        var on = t.getAttribute('data-ff-shop-tab') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focusTab) t.focus();
      });

      panels.forEach(function (p) {
        if (p === nextPanel) return;
        if (p.hidden) return;
        p.classList.remove('is-shown');
        if (reduced) {
          p.hidden = true;
        } else {
          window.setTimeout(function () { p.hidden = true; }, 260);
        }
      });

      nextPanel.hidden = false;
      void nextPanel.offsetWidth;
      nextPanel.classList.add('is-shown');
      revealCards(nextPanel);

      try { root.dataset.ffShopActive = id; } catch (e) {}
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-ff-shop-tab'), false);
      });
      tab.addEventListener('keydown', function (e) {
        var idx = i;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          activate(tabs[(idx + 1) % tabs.length].getAttribute('data-ff-shop-tab'), true);
        } else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          activate(tabs[(idx - 1 + tabs.length) % tabs.length].getAttribute('data-ff-shop-tab'), true);
        }
      });
    });

    var initial = root.dataset.ffShopActive || (tabs[0] && tabs[0].getAttribute('data-ff-shop-tab'));
    if (initial) activate(initial, false);
  }

  function init() {
    document.querySelectorAll('[data-ff-shop]').forEach(initShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
